module.exports = __webpack_public_path__ + "static/media/c_logo.8060d20d.png";